<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div
        style="position: fixed;height: 70px;background: #f0f2f5;width: 100%;z-index: 999;box-shadow:0 1px 6px 0 rgb(32 33 36 / 28%);display: flex;justify-content: space-between;align-items: center">
      <img src="../assets/qqqqqq.png" style="width: 180px;height: 50px" @click="$router.push('/')">
      <div style="padding:20px 20px" @click="show = true">
        <van-icon style="font-size: 32px" name="wap-nav"/>
      </div>
    </div>

    <van-popup v-model="show" position="right" :style="{ height: '100%',width:'80%' }" closeable
               close-icon-position="top-right">
      <div style="height: 100%;width: 100%">
        <div style="width: 100%">
          <img src="../assets/qqqqqq.png" alt="天使针" title="天使针" style="width: 180px;height: 50px">
        </div>
        <van-cell title="首页" is-link @click="$router.push('/')"/>
        <van-cell style="color: #00bef1" title="授权医师/医院/运营中心/设计师查询" is-link @click="reload"/>
      </div>
    </van-popup>
    <div style="padding-top: 70px">
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(image, index) in imagesList" :key="index">
          <img :src="image.imageUrl" width="100%"/>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div>

      <van-tabs v-model="active" @click="empty"  :ellipsis="false">
        <van-tab name="1" title="认证医师查询">
          <div style="width: 90%;margin: 20px auto">
            <van-cell is-link @click="actionShowYs = true" title="选择省份" :value="drCity"/>
            <van-cell style="margin-top: 10px" is-link @click="actionShowYsCity = true" title="选择城市" :aria-disabled="drCity" :value="drCitye"/>
            <van-cell style="margin-top: 10px" is-link @click="actionHsShowYs = true" title="选择医院"
                      :value="params.hospital"/>
            <van-cell style="margin-top: 10px;justify-content: space-between;">
              <template #right-icon>请输入医生名称
                <input class="cell-number"  style="text-align: right"
                       v-model="params.drName" placeholder="请输入" @input="changeDrName">
              </template>
            </van-cell>
          </div>
          <div style="width: 90%;margin: 40px auto">
            <van-row>
              <van-col span="12" v-for="(item,index) in listDr" :key="index">
                <div class="item-dr">
                  <img style="height: 160px;
    margin: 0 auto;
    display: block;"
                       alt="天使针" title="天使针"
                       :src="'https://tsz.hzmed.top'+item.headUrl">
                  <div class="name">{{item.doctorName}} {{item.duty}}</div>
                  <div class="ground">{{item.certifiType }}</div>
                  <div class="hospital"> {{item.hospitalName}}</div>
                </div>
              </van-col>

            </van-row>


          </div>
          <van-pagination v-model="params.pageNum" :total-items="totala" @change="change" mode="simple" />

        </van-tab>
        <van-tab name="2"  title="授权医院查询">
          <div style="width: 90%;margin: 20px auto">
            <van-cell is-link @click="actionShowCs = true" title="选择省份" :value="city"/>
            <van-cell style="margin-top: 10px" is-link @click="actionShowCsaa = true" title="选择城市"  :value="cityaa"/>
            <van-cell style="margin-top: 10px" is-link @click="porductShow= true" title="产品"  :value="porductName"/>
            <van-cell style="margin-top: 10px;justify-content: space-between;">
              <template #right-icon>请输入医院名称
                <input class="cell-number"  style="text-align: right"
                       v-model="params2.hospital" placeholder="请输入" @input="changeDrName">
              </template>
            </van-cell>

<!--            <van-cell style="margin-top: 10px" is-link @click="actionHsShowCs = true" title="选择医院"-->
<!--                      :value="params2.hospital"/>-->
          </div>
          <div style="width: 90%;margin: 40px auto">
            <van-row>

              <van-col span="12" v-for="(item,index) in listCity" :key="index">
                <div class="item-dr">
                  <img style="height: 160px;
    margin: 0 auto;
    display: block;"
                       alt="天使针" title="天使针"
                       :src="'https://tsz.hzmed.top'+item.headUrl">
                  <div class="name">{{item.hospitalName}}</div>
                  <div class="ground" v-if="item.productType==1">天使针骨胶原认证医院</div>
                  <div class="ground" v-else-if="item.productType==2">天使针玻尿酸认证医院</div>
                  <div class="ground" v-else-if="item.productType==3">天使针同种骨认证医院</div>
                  <div class="ground" v-else-if="item.productType==4">天使针人工骨认证医院</div>
                  <div class="ground" v-else-if="item.productType==5">天使针仿生骨认证医院</div>
                  <div class="ground" v-else>天使针认证医院</div>
                  <div class="hospital"> {{item.provinceName}} - {{item.cityName}}</div>
                </div>
              </van-col>
            </van-row>
          </div>
          <van-pagination v-model="params2.pageNum" :total-items="totalb" @change="change" mode="simple" />

        </van-tab>
        <van-tab name="3"  title="运营中心">
          <div style="width: 90%;margin: 20px auto">
            <van-cell is-link @click="actionShowCs = true" title="选择省份" :value="city"/>
            <van-cell style="margin-top: 10px" is-link @click="actionShowCsaa = true" title="选择城市"  :value="cityaa"/>
            <van-cell style="margin-top: 10px;justify-content: space-between;">
              <template #right-icon>请输入医院名称
                <input class="cell-number"  style="text-align: right"
                       v-model="params2.hospital" placeholder="请输入" @input="changeDrName">
              </template>
            </van-cell>

            <!--            <van-cell style="margin-top: 10px" is-link @click="actionHsShowCs = true" title="选择医院"-->
            <!--                      :value="params2.hospital"/>-->
          </div>
          <div style="width: 90%;margin: 40px auto">
            <van-row>

              <van-col span="12" v-for="(item,index) in listCity" :key="index">
                <div class="item-dr">
                  <img style="height: 160px;
    margin: 0 auto;
    display: block;"
                       alt="天使针" title="天使针"
                       :src="'https://tsz.hzmed.top'+item.headUrl">
                  <div class="name">{{item.hospitalName}}</div>

                  <div class="hospital"> {{item.provinceName}} - {{item.cityName}}</div>
                </div>
              </van-col>
            </van-row>
          </div>
          <van-pagination v-model="params2.pageNum" :total-items="totalb" @change="change" mode="simple" />

        </van-tab>
        <van-tab name="4" title="认证美学设计师">
          <div style="width: 90%;margin: 20px auto">
            <van-cell is-link @click="actionShowYs = true" title="选择省份" :value="drCity"/>
            <van-cell style="margin-top: 10px" is-link @click="actionShowYsCity = true" title="选择城市" :aria-disabled="drCity" :value="drCitye"/>
            <van-cell style="margin-top: 10px" is-link @click="actionHsShowYs = true" title="选择医院"
                      :value="params.hospital"/>
            <van-cell style="margin-top: 10px;justify-content: space-between;">
              <template #right-icon>请输入专家名称
                <input class="cell-number"  style="text-align: right"
                       v-model="params.drName" placeholder="请输入" @input="changeDrName">
              </template>
            </van-cell>
          </div>
          <div style="width: 90%;margin: 40px auto">
            <van-row>

              <van-col span="12" v-for="(item,index) in listDr2" :key="index">
                <div class="item-dr">
                  <img style="height: 160px;
    margin: 0 auto;
    display: block;"
                       alt="天使针" title="天使针"
                       :src="'https://tsz.hzmed.top'+item.headUrl">
                  <div class="name">{{item.doctorName}} {{item.duty}}</div>
                  <div class="ground">{{item.certifiType}}</div>
                  <div class="hospital"> {{item.hospitalName}}</div>
                </div>
              </van-col>
            </van-row>
          </div>
          <van-pagination v-model="params.pageNum" :total-items="totala" @change="change" mode="simple" />

        </van-tab>
      </van-tabs>
    </div>
    <div style="margin-bottom: 10px">
<!--      <img src="../assets/gxm.jpg" alt="天使针" title="天使针" class="imgPX">-->
      <div></div>
    </div>

    <van-action-sheet v-model="actionShowYs" round position="bottom">
      <van-area title="请选择省份" :area-list="areaList" :defaultIndex="defaultIndex" :columns-num="1"
                @confirm="confim"/>
    </van-action-sheet>
    <van-action-sheet v-model="actionShowYsCity" round position="bottom">
      <van-picker title="请选择城市" :columns="cityArr" :defaultIndex="defaultIndex"     show-toolbar
                @confirm="confim2"/>
    </van-action-sheet>
    <van-action-sheet v-model="actionShowCs" round position="bottom">

      <van-area title="请选择省份" :area-list="areaList" :defaultIndex="defaultIndex" :columns-num="1"
                @confirm="confim"/>
    </van-action-sheet>
    <van-action-sheet v-model="actionShowCsaa" round position="bottom">
      <van-picker title="请选择城市" :columns="cityArr2" :defaultIndex="defaultIndex"     show-toolbar
                  @confirm="confim2"/>
    </van-action-sheet>
    <van-action-sheet v-model="actionHsShowYs" round position="bottom">
      <van-picker
          value-key="hospitalName"
          title="请选择医院"
          show-toolbar
          :columns="columnsDr"
          @confirm="confimHs"
      />
    </van-action-sheet>
    <van-action-sheet v-model="actionHsShowCs" round position="bottom">
      <van-picker
          title="请选择医院"
          value-key="hospitalName"
          show-toolbar
          :columns="columns"
          @confirm="confimHs"
      />
    </van-action-sheet>

    <van-action-sheet v-model="porductShow" round position="bottom">
      <van-picker
          title="请选择产品"
          value-key="name"
          show-toolbar
          :columns="productList"
          @confirm="confimPro"
      />
    </van-action-sheet>
  </div>


</template>

<script>
import img from "@assets/banner/1.png";
import img2 from "@assets/banner/2.png";
import img3 from '../assets/banner/3.png'

import {areaList} from '@vant/area-data';
import {doctor, hospital,hospitallist} from "@http/APIConfig";
import {baseUrl, queryByType} from "../http/APIConfig";


export default {
  name: "search",
  data() {
    return {
      show: false,
      imagesList:[],
      porductShow:false,
      actionShowYs: false,
      actionShowCs: false,
      actionHsShowYs: false,
      actionHsShowCs: false,
      actionShowYsCity:false,
      actionShowCsaa:false,
      defaultIndex: 0,
      areaList: areaList,
      drCity: '',
      drCitye:'',
      city: '',
      cityaa:'',
      totala:'',
      totalb:"",
      active: this.$route.query.type+'',
      images: [
        img,
        img2,
        img3,
      ],
      productList:[{name:'骨胶原',key:'1'},
        {name:'玻尿酸',key:'2'},{name:'同种骨',key:'3'},{name:'人工骨',key:'4'},
        {name:'仿生骨',key:'5'},
        {name:'法国春天带',key:'6'},
        {name:'缇致水晶线',key:'7'}

      ],
      columns: [],
      columnsDr:[],
      listCity: [],
      listDr: [],
      listDr2:[],
      cityArr:[],
      cityArr2:[],
      params: {
        drName: '',
        provinceCode: '',
        cityCode: '',
        hospital: '',
        pageNum: 1,
        pageSize: 10,

      },
      params2: {
        provinceCode: '',
        cityCode: '',
        hospital: '',
        pageNum: 1,
        pageSize: 10,

      },
      porductName:""
    }
  },
  methods: {
    change(){
      this.getList()
    },
    empty(){
        this.params = {
          drName: '',
          provinceCode: '',
          cityCode: '',
          hospital: '',
          pageNum: 1,
          pageSize: 10,
        }
        this.params2={
          provinceCode: '',
          cityCode: '',
          hospital: '',
          pageNum: 1,
          pageSize: 10,
        }
        this.changeDrName()
      this.drCity = ''
      this.city=''
      this.cityaa=''
      this.drCitye = ''
      this.productType = ''
      this.porductName=  ''
    },
    reload() {
      window.location.reload()
    },
    confimPro(e){
      this.productType = e.key
      this.porductName= e.name
      this.porductShow = false
      this.getList()
    },
    confimHs(e) {
      this.actionHsShowCs = false
      this.actionHsShowYs = false
      if (this.active === '1') {
        this.params.hospital=e.hospitalName
        // this.params.drName = ''
      } else {
        this.params2.hospital=e.hospitalName
      }
      this.getList()
    },
    confim2(e){
      if (this.active === '1'||this.active === '4') {
        this.drCitye = e.text
        this.params.hospital = ''
        this.params.cityCode = e.code
        this.actionShowYsCity = false

      } else {
        this.cityaa= e.text
        this.params2.hospital = ''
        this.params2.cityCode = e.code
        this.actionShowCsaa = false
      }
      this.getHospital()
      this.getList()
    },
    confim(e) {
      let code = e[0].code.substring(0,2)
      let city = []
      for (let i in this.areaList.city_list){
        if(i.startsWith(code)){
          city.push({
            text:this.areaList.city_list[i],code : i
          })
        }
      }
      this.actionShowYs = false
      this.actionShowCs = false
      if (this.active === '1'||this.active === '4') {
        this.cityArr = city
        this.drCitye = ''
        this.drCity = ''
        e.forEach(item => {
          // 医生
          if(!(this.drCity==item.name)){
            this.drCity += item.name
          }
        })
        this.params.hospital = ''
        this.params.provinceCode = e[0].code
        this.params.cityCode = ''
      } else {
        this.cityArr2 = city
        this.city = ''
        this.cityaa=  ''
            e.forEach(item => {
          //城市
          if(!(this.city==item.name)){
            this.city += item.name
          }
        })
        this.params2.hospital = ''
        this.params2.provinceCode = e[0].code
        this.params2.cityCode =''
      }
      this.getHospital()
      this.getList()
    },
    getHospital() {
      if (this.active === '1'||this.active === '4') {
        hospital({
          cityCode: this.params.cityCode ,provinceCode: this.params.provinceCode,

        }).then(res => {
          this.columnsDr= res.data
        })
      } else  if (this.active === '2'){
        hospital({
          cityCode: this.params2.cityCode ,provinceCode: this.params2.provinceCode
        }).then(res => {
          this.columns= res.data
        })
      } else  if (this.active === '3'){
        hospital({
          cityCode: this.params2.cityCode ,provinceCode: this.params2.provinceCode
        }).then(res => {
          this.columns= res.data
        })
      }
    },
    getList() {
      if (this.active === '1') {
        doctor({
          cityCode: this.params.cityCode , doctorName: this.params.drName, hospitalName: this.params.hospital, provinceCode: this.params.provinceCode,type:0,
          pageNum: this.params.pageNum,
          pageSize: 10,
        }).then(res => {
          this.listDr = res.rows
          this.totala = res.total
        })

      } else  if (this.active === '2') {
        // 只有选择了省份、城市或输入了医院名称才查询
        if (this.params2.provinceCode || this.params2.cityCode || this.params2.hospital) {
          hospitallist({
            cityCode: this.params2.cityCode , hospitalName: this.params2.hospital, provinceCode: this.params2.provinceCode,type:1,productType:this.productType,
            pageNum: this.params2.pageNum,
            pageSize: 10,
          }).then(res => {
            this.listCity= res.rows
            this.totalb = res.total
          })
        } else {
          // 清空列表
          this.listCity = []
          this.totalb = 0
        }
      }else  if (this.active === '3') {
        hospitallist({
          cityCode: this.params2.cityCode , hospitalName: this.params2.hospital, provinceCode: this.params2.provinceCode,type:2,
          pageNum: this.params2.pageNum,
          pageSize: 10,
        }).then(res => {
          this.listCity= res.rows
          this.totalb = res.total
        })
      } else  if (this.active === '4') {
        doctor({
          cityCode: this.params.cityCode , doctorName: this.params.drName, hospitalName: this.params.hospital, provinceCode: this.params.provinceCode,type:1,
          pageNum: this.params.pageNum,
          pageSize: 10,
        }).then(res => {
          this.listDr2 = res.rows
          this.totala = res.total
        })
      }
    },
    changeDrName() {
      this.getList()
    }

  },
  mounted() {
    // 认证医师查询默认加载
    doctor({type:0,  pageNum: this.params.pageNum,
      pageSize: 10,}).then(res=>{
      this.listDr = res.rows
      this.totala = res.total
    })
    // 认证美学设计师默认加载
    doctor({type:1,  pageNum: this.params.pageNum,
      pageSize: 10}).then(res=>{
      this.listDr2 = res.rows
      this.totala = res.total
    })
    // 运营中心默认加载
    hospitallist({
      type:2,
      pageNum: this.params2.pageNum,
      pageSize: 10
    }).then(res=>{
      this.listCity= res.rows
      this.totalb = res.total
    })
    hospital().then(res=>{
      this.columnsDr= res.data
      this.columns= res.data
    })
    queryByType(
        {
          // categoryType:1,
          type:0}
    ).then(res=>{
      res.rows.forEach(item=>{
        item.imageUrl = baseUrl+item.imageUrl
        if(item.categoryType ==1){
          this.imagesList.push(item)
          this.imagesList.sort((a, b) => a.sortNum - b.sortNum);
        }else if (item.categoryType ==2){
          this.imagesList2.push(item)
          this.imagesList2.sort((a, b) => a.sortNum - b.sortNum);
        }else {
          this.imagesList3.push(item)
          this.imagesList3.sort((a, b) => a.sortNum - b.sortNum);
        }
      })
    })
  },

}
</script>

<style scoped lang="less">
.item-dr {
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;
  margin: 10px;
  padding-bottom: 15px;
  overflow: hidden;

  .name {
    padding: 10px;
    font-size: 13px;
  }

  .ground {
    font-size: 13px;
    padding-left: 10px;
  }

  .hospital {
    font-size: 13px;
    padding-left: 10px;
    padding-top: 5px;
  }

}

.cell-number {
  border: 0;
  text-align: right;
  float: right;
}
</style>